// Cost calculation constants - matching the edge function
export const CLASS_RATE_PER_HOUR = 100;

export const TIER_RATE: Record<string, number> = {
  "ไม่มี tier": 0,
  "Tier 1": 0,
  "Tier 2": 10,
  "Tier 3": 30,
  "Tier 4": 50,
};

export const GRADE_RATE: Record<string, number> = {
  "ป.1": 0,
  "ป.2": 0,
  "ป.3": 0,
  "ป.4": 0,
  "ป.5": 0,
  "ป.6": 0,
  "ม.1": 25,
  "ม.2": 25,
  "ม.3": 25,
  "ม.4": 25,
  "ม.5": 25,
  "ม.6": 25,
  "มหาวิทยาลัย": 50,
};

export const CLASS_TYPE_RATE: Record<string, number> = {
  "Premiere/TH": 10,
  "Premiere/Inter": 30,
  // backward compat
  "PM/TH": 10,
  "PM/INTER": 30,
};

export const LOCATION_RATE: Record<string, number> = {
  // ค่าใหม่ (ภาษาไทย)
  "ออนไลน์": 0,
  "งามวงศ์วาน": 50,
  "สยาม": 50,
  // ค่าเก่า (backward compatibility)
  "online": 0,
  "onsite": 50,
};

export interface CostBreakdown {
  base: number;
  gradeRate: number;
  classTypeRate: number;
  locationRate: number;
  tierRate: number;
  commission: number;
  hours: number;
  total: number;
  // Labels for display
  gradeLabel: string | null;
  classTypeLabel: string | null;
  locationLabel: string | null;
  tierLabel: string | null;
}

export function getCostBreakdown(
  grade: string | null,
  classType: string | null,
  location: string | null,
  hasCommission: boolean,
  tier: string | null = null,
  hours: number = 1
): CostBreakdown {
  const gradeRate = grade ? (GRADE_RATE[grade] ?? 0) : 0;
  const classTypeRate = classType ? (CLASS_TYPE_RATE[classType] ?? 0) : 0;
  const locationRate = location ? (LOCATION_RATE[location] ?? 0) : 0;
  const tierRate = tier ? (TIER_RATE[tier] ?? 0) : 0;
  const commission = hasCommission ? 50 : 0;

  const total = (CLASS_RATE_PER_HOUR + gradeRate + classTypeRate + locationRate + tierRate) * hours + commission;

  return {
    base: CLASS_RATE_PER_HOUR,
    gradeRate,
    classTypeRate,
    locationRate,
    tierRate,
    commission,
    hours,
    total,
    gradeLabel: grade,
    classTypeLabel: classType,
    locationLabel: location,
    tierLabel: tier,
  };
}

export function calculateTrialCost(
  grade: string | null,
  classType: string | null,
  location: string | null,
  hasCommission: boolean,
  tier: string | null = null,
  hours: number = 1
): number {
  return getCostBreakdown(grade, classType, location, hasCommission, tier, hours).total;
}
